const Mask = ({ style, children }) => {
  return (
    <div style={style} className={"scrolling-modal-mask"}>
      {children}
    </div>
  );
};

export default Mask;
